import Controller from './Controller';
import type Report from '../checks/Report';
import { CDMC_Method, CEMC_Method } from '../commands/metamodel/complex/index';
import type { OrId, MethodUpdates } from '../commands/types';
import type { IMethod } from '../../stores/model/metamodel/method';

/**
 * Edit or delete a method
 */
export default class EditMethodController extends Controller {
  async editMethod(id: OrId<IMethod>, updates: MethodUpdates): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = CEMC_Method(model, id, updates);
      return checks;
    });
  }

  async deleteMethod(id: OrId<IMethod>): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = CDMC_Method(model, id);
      return checks;
    });
  }
}
